import { _ as __rest, a as __assign } from './tslib.es6-ff7ae7b8.js';
import { c as classNames } from './index-b0444989.js';
import * as React from 'react';
import React__default from 'react';
import { Link } from 'react-router-dom';
import { s as skeletonStyles } from './skeleton.module-58f87ef6.js';
import { u as useTheme, d as defaultTheme } from './ThemeProvider-22ee39e3.js';

function ReloadIcon(_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React__default.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5493 2.67172C23.2494 2.67172 23.817 3.23929 23.817 3.93942V9.01022C23.817 9.71035 23.2494 10.2779 22.5493 10.2779H17.4784C16.7783 10.2779 16.2107 9.71035 16.2107 9.01022C16.2107 8.31009 16.7783 7.74252 17.4784 7.74252H21.2816V3.93942C21.2816 3.23929 21.8491 2.67172 22.5493 2.67172Z", fill: fillColor }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9499 4.12595C12.3923 3.81562 10.7776 3.97424 9.31017 4.58173C7.84272 5.18921 6.58841 6.21828 5.7059 7.53874C4.8234 8.85921 4.35236 10.4118 4.35236 12C4.35236 13.5882 4.8234 15.1407 5.7059 16.4612C6.58841 17.7817 7.84272 18.8107 9.31017 19.4182C10.7776 20.0257 12.3923 20.1843 13.9499 19.874C15.5075 19.5637 16.9381 18.7984 18.0606 17.6749C18.5555 17.1796 19.3582 17.1793 19.8534 17.6741C20.3487 18.169 20.349 18.9717 19.8542 19.4669C18.3771 20.9452 16.4948 21.9522 14.4453 22.3605C12.3958 22.7688 10.2712 22.5601 8.34039 21.7608C6.40953 20.9615 4.75913 19.6075 3.59794 17.87C2.43675 16.1326 1.81696 14.0897 1.81696 12C1.81696 9.91021 2.43675 7.86739 3.59794 6.12993C4.75913 4.39248 6.40953 3.03845 8.34039 2.23912C10.2712 1.4398 12.3958 1.23109 14.4453 1.63941C16.4942 2.04763 18.3761 3.05421 19.853 4.53187L19.8542 4.53302L23.4443 8.11259C23.9401 8.60693 23.9413 9.40959 23.447 9.90539C22.9526 10.4012 22.15 10.4024 21.6542 9.90803L18.0623 6.32677L18.0606 6.32509C16.9381 5.20159 15.5075 4.43627 13.9499 4.12595Z", fill: fillColor })));
}

var styles = {"button":"Button_button_aa6e6217","fullWidth":"Button_fullWidth_aa6e6217","noShadow":"Button_noShadow_aa6e6217","label":"Button_label_aa6e6217","focus-visible":"Button_focus-visible_aa6e6217","white":"Button_white_aa6e6217","disabled":"Button_disabled_aa6e6217","secondary":"Button_secondary_aa6e6217","tertiary":"Button_tertiary_aa6e6217","transparent":"Button_transparent_aa6e6217","interface":"Button_interface_aa6e6217","skeleton":"Button_skeleton_aa6e6217","loading":"Button_loading_aa6e6217","icon":"Button_icon_aa6e6217","rotate":"Button_rotate_aa6e6217","children":"Button_children_aa6e6217","size-large":"Button_size-large_aa6e6217","size-small":"Button_size-small_aa6e6217","size-extra-small":"Button_size-extra-small_aa6e6217","spinner-left":"Button_spinner-left_aa6e6217","spinner-right":"Button_spinner-right_aa6e6217"};

function isPropsForAnchor(props) {
    return "href" in props;
}
function isPropsForLink(props) {
    return "to" in props;
}
var Button = React.forwardRef(function Button(props, ref) {
    var _a;
    var className = props.className, isLoading = props.isLoading, _b = props.variant, variant = _b === void 0 ? "primary" : _b, _c = props.size, size = _c === void 0 ? "medium" : _c, label = props.label, _d = props.color, colorProp = _d === void 0 ? "action" : _d, isSkeleton = props.isSkeleton, disabled = props.disabled, href = props.href, to = props.to, children = props.children, style = props.style, noShadow = props.noShadow, fullWidth = props.fullWidth, _e = props.spinnerAlign, spinnerAlign = _e === void 0 ? "center" : _e, _f = props.labelColor, labelProp = _f === void 0 ? "action" : _f, transparent = props.transparent, buttonProps = __rest(props, ["className", "isLoading", "variant", "size", "label", "color", "isSkeleton", "disabled", "href", "to", "children", "style", "noShadow", "fullWidth", "spinnerAlign", "labelColor", "transparent"]);
    var isDisabled = disabled || isSkeleton;
    var colors = useTheme().colors;
    var color = React.useMemo(function () {
        // In case a non-default color is passed in, use action
        if (!Object.keys(defaultTheme).includes(colorProp) &&
            "interface" !== colorProp &&
            "white" !== colorProp) {
            return "action";
        }
        return colorProp;
    }, [colorProp]);
    var labelColor = React.useMemo(function () {
        if (!labelProp) {
            return "action";
        }
        return labelProp;
    }, [labelProp]);
    var labelPropIsOrchardColor = Object.keys(defaultTheme).includes(labelProp) ||
        "interface" === labelProp;
    var hasShadow = !noShadow && variant !== "tertiary" && !isDisabled;
    var buttonClassNames = classNames(styles.button, styles["size-".concat(size)], styles["spinner-".concat(spinnerAlign)], (_a = {},
        _a[styles.loading] = isLoading,
        _a[styles.disabled] = isDisabled,
        _a[styles.secondary] = variant === "secondary",
        _a[styles.tertiary] = variant === "tertiary",
        _a[styles.interface] = color === "interface",
        _a[styles.white] = color === "white",
        _a[skeletonStyles.skeleton] = isSkeleton,
        _a[styles.skeleton] = isSkeleton,
        _a[styles.noShadow] = !hasShadow,
        _a[styles.transparent] = transparent,
        _a[styles.fullWidth] = fullWidth,
        _a), className);
    var buttonCssColors = React.useMemo(function () {
        if (color === "interface") {
            return {
                primary: colors["color-ui-interface-10"],
                label: colors["color-ui-interface"],
                labelHover: colors["color-ui-interface-mid"],
                labelActive: colors["color-ui-interface-dark"],
                altHover: colors["color-ui-interface-5"],
                altActive: colors["color-ui-interface-10"],
                hover: colors["color-ui-interface-20"],
                active: colors["color-ui-interface-40"],
            };
        }
        if (color === "white") {
            return {
                primary: colors["color-white"],
                label: labelPropIsOrchardColor
                    ? colors["color-ui-".concat(labelColor)]
                    : labelProp,
                labelHover: labelPropIsOrchardColor
                    ? colors["color-ui-".concat(labelColor, "-mid")]
                    : labelProp,
                labelActive: labelPropIsOrchardColor
                    ? colors["color-ui-".concat(labelColor, "-dark")]
                    : labelProp,
                altHover: colors["color-white"],
                altActive: labelPropIsOrchardColor
                    ? colors["color-ui-".concat(labelColor, "-80")]
                    : labelProp,
                hover: colors["color-white"],
                active: colors["color-white"],
                color: labelPropIsOrchardColor
                    ? colors["color-ui-".concat(labelColor)]
                    : labelProp,
            };
        }
        return {
            primary: colors["color-ui-".concat(color)],
            label: colors["color-white"],
            labelHover: colors["color-white"],
            labelActive: colors["color-white"],
            altHover: colors["color-ui-".concat(color, "-5")],
            altActive: colors["color-ui-".concat(color, "-20")],
            hover: colors["color-ui-".concat(color, "-mid")],
            active: colors["color-ui-".concat(color, "-dark")],
        };
    }, [color, colors, labelColor, labelProp, labelPropIsOrchardColor]);
    var buttonCssStyles = React.useMemo(function () {
        return {
            "--color-primary": buttonCssColors.primary,
            "--color-label": buttonCssColors.label,
            "--color-label-hover": buttonCssColors.labelHover,
            "--color-label-active": buttonCssColors.labelActive,
            "--color-alt-hover": buttonCssColors.altHover,
            "--color-alt-active": buttonCssColors.altActive,
            "--color-hover": buttonCssColors.hover,
            "--color-active": buttonCssColors.active,
        };
    }, [buttonCssColors]);
    var buttonContent = function () {
        var fillColor;
        if (color === "interface" || color === "white")
            fillColor = buttonCssColors.label;
        else if (variant === "primary")
            fillColor = colors["color-white"];
        else
            fillColor = buttonCssColors.primary;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { "aria-hidden": isSkeleton ? "true" : undefined, className: styles.label, "data-testid": "button-content" }, (children && React.createElement("div", { className: styles.children }, children)) ||
                label),
            React.createElement("span", { "aria-hidden": isSkeleton ? "true" : undefined, className: styles.icon, "data-testid": buttonProps["data-testid"]
                    ? "".concat(buttonProps["data-testid"], "-icon")
                    : "button-icon" },
                React.createElement(ReloadIcon, { fillColor: fillColor }))));
    };
    if (isPropsForLink(props) && !!to) {
        return (React.createElement(Link, __assign({ ref: ref, to: to, className: buttonClassNames, "aria-busy": isSkeleton, "aria-disabled": isDisabled, "aria-label": label, style: __assign(__assign({}, style), buttonCssStyles), "data-loading": isLoading }, buttonProps), buttonContent()));
    }
    return isPropsForAnchor(props) && !!href ? (React.createElement("a", __assign({ ref: ref, className: buttonClassNames, "aria-busy": isSkeleton, "aria-label": label, "aria-disabled": isDisabled, href: href, style: __assign(__assign({}, style), buttonCssStyles), "data-loading": isLoading }, buttonProps), buttonContent())) : (React.createElement("button", __assign({ ref: ref, className: buttonClassNames, "aria-busy": isSkeleton, "aria-label": label, disabled: isDisabled, style: __assign(__assign({}, style), buttonCssStyles), "data-loading": isLoading }, buttonProps), buttonContent()));
});
var buttonStyles = __assign({}, styles);

export { Button as B, ReloadIcon as R, buttonStyles as b };
